import { exists } from '../runtime.js';
import './ApiActivityType.js';
import './ApiAdditionalInfoType.js';
import './ApiAirportType.js';
import './ApiBaggageType.js';
import './ApiBaggageUnitType.js';
import './ApiBaseDataSource.js';
import { ApiBaseModelFromJSONTyped, ApiBaseModelToJSON } from './ApiBaseModel.js';
import { ApiBlockchainWalletFromJSON, ApiBlockchainWalletToJSON } from './ApiBlockchainWallet.js';
import { ApiBookedItemFromJSON, ApiBookedItemToJSON } from './ApiBookedItem.js';
import './ApiBookingAction.js';
import { ApiBookingCustomPropertyFromJSON, ApiBookingCustomPropertyToJSON } from './ApiBookingCustomProperty.js';
import { ApiBookingStateFromJSON, ApiBookingStateToJSON } from './ApiBookingState.js';
import './ApiCabinClass.js';
import './ApiCamperFeatureType.js';
import { ApiCaptureDataFromJSON, ApiCaptureDataToJSON } from './ApiCaptureData.js';
import { ApiCartDataFromJSON, ApiCartDataToJSON } from './ApiCartData.js';
import { ApiClientFromJSON, ApiClientToJSON } from './ApiClient.js';
import './ApiClientType.js';
import './ApiComponentPriceType.js';
import './ApiComponentType.js';
import './ApiConfigurationDataType.js';
import './ApiDebitType.js';
import { ApiDepositPaymentDataFromJSON, ApiDepositPaymentDataToJSON } from './ApiDepositPaymentData.js';
import './ApiDirection.js';
import { ApiDiscountFromJSON, ApiDiscountToJSON } from './ApiDiscount.js';
import './ApiDistanceUnit.js';
import { ApiDocumentFromJSON, ApiDocumentToJSON } from './ApiDocument.js';
import './ApiDocumentSubType.js';
import './ApiDocumentType.js';
import './ApiDurationType.js';
import './ApiFilterCategory.js';
import './ApiFilterType.js';
import { ApiFinalPaymentDataFromJSON, ApiFinalPaymentDataToJSON } from './ApiFinalPaymentData.js';
import './ApiFuelType.js';
import './ApiGender.js';
import './ApiImageType.js';
import './ApiInventory.js';
import { ApiItemFromJSON, ApiItemToJSON } from './ApiItem.js';
import './ApiItemType.js';
import { ApiNoteFromJSON, ApiNoteToJSON } from './ApiNote.js';
import './ApiNoteOriginType.js';
import './ApiNoteType.js';
import './ApiPackagePriceComponentType.js';
import { ApiPaymentFromJSON, ApiPaymentToJSON } from './ApiPayment.js';
import './ApiPaymentDataType.js';
import { ApiPaymentOptionFromJSON, ApiPaymentOptionToJSON } from './ApiPaymentOption.js';
import { ApiPaymentStateFromJSON, ApiPaymentStateToJSON } from './ApiPaymentState.js';
import { ApiPriceFromJSON, ApiPriceToJSON } from './ApiPrice.js';
import './ApiPriceModifierType.js';
import './ApiPriceType.js';
import './ApiRecommendationServiceType.js';
import './ApiRelatedServiceRelationType.js';
import './ApiRole.js';
import './ApiRowCharacteristics.js';
import './ApiSeatCharacteristics.js';
import './ApiServiceSelectionType.js';
import './ApiSortDirection.js';
import './ApiSortOption.js';
import './ApiSpecialRequestGroup.js';
import './ApiStaticContentType.js';
import './ApiTaxDisplay.js';
import './ApiTransmissionType.js';
import './ApiTravelStatusEnum.js';
import { ApiTravelerFromJSON, ApiTravelerToJSON } from './ApiTraveler.js';
import './ApiTravelerType.js';
import './ApiVoucherDeliveryType.js';
import './ApiWalletType.js';

/* tslint:disable */
function ApiBookingFromJSON(json) {
    return ApiBookingFromJSONTyped(json, false);
}
function ApiBookingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...ApiBaseModelFromJSONTyped(json, ignoreDiscriminator),
        'bookingNumber': json['bookingNumber'],
        'bookingState': ApiBookingStateFromJSON(json['bookingState']),
        'bookingDate': (json['bookingDate']),
        'price': ApiPriceFromJSON(json['price']),
        'openAmount': ApiPriceFromJSON(json['openAmount']),
        'totalDiscount': ApiPriceFromJSON(json['totalDiscount']),
        'travelers': (json['travelers'].map(ApiTravelerFromJSON)),
        'payments': (json['payments'].map(ApiPaymentFromJSON)),
        'items': (json['items'].map(ApiItemFromJSON)),
        'bookedItems': (json['bookedItems'].map(ApiBookedItemFromJSON)),
        'documents': (json['documents'].map(ApiDocumentFromJSON)),
        'client': ApiClientFromJSON(json['client']),
        'affiliateNumber': !exists(json, 'affiliateNumber') ? undefined : json['affiliateNumber'],
        'travelStartDate': (json['travelStartDate']),
        'travelEndDate': (json['travelEndDate']),
        'paymentState': ApiPaymentStateFromJSON(json['paymentState']),
        'paymentDueDate': !exists(json, 'paymentDueDate') ? undefined : (json['paymentDueDate']),
        'depositPayment': !exists(json, 'depositPayment') ? undefined : ApiDepositPaymentDataFromJSON(json['depositPayment']),
        'finalPayment': !exists(json, 'finalPayment') ? undefined : ApiFinalPaymentDataFromJSON(json['finalPayment']),
        'notes': !exists(json, 'notes') ? undefined : (json['notes'].map(ApiNoteFromJSON)),
        'promoCodes': json['promoCodes'],
        'bookingCustomProperties': !exists(json, 'bookingCustomProperties') ? undefined : (json['bookingCustomProperties'].map(ApiBookingCustomPropertyFromJSON)),
        'catalogCode': !exists(json, 'catalogCode') ? undefined : json['catalogCode'],
        'salesChannel': json['salesChannel'],
        'rebookingId': !exists(json, 'rebookingId') ? undefined : json['rebookingId'],
        'changedAmount': !exists(json, 'changedAmount') ? undefined : ApiPriceFromJSON(json['changedAmount']),
        'cartData': !exists(json, 'cartData') ? undefined : ApiCartDataFromJSON(json['cartData']),
        'paymentOption': !exists(json, 'paymentOption') ? undefined : ApiPaymentOptionFromJSON(json['paymentOption']),
        'captureData': !exists(json, 'captureData') ? undefined : (json['captureData'].map(ApiCaptureDataFromJSON)),
        'blockchainWallet': !exists(json, 'blockchainWallet') ? undefined : ApiBlockchainWalletFromJSON(json['blockchainWallet']),
        'metaData': !exists(json, 'metaData') ? undefined : json['metaData'],
        'sumPriceSysCurr': !exists(json, 'sumPriceSysCurr') ? undefined : ApiPriceFromJSON(json['sumPriceSysCurr']),
        'discounts': !exists(json, 'discounts') ? undefined : (json['discounts'].map(ApiDiscountFromJSON)),
        'brand': !exists(json, 'brand') ? undefined : json['brand'],
    };
}
function ApiBookingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...ApiBaseModelToJSON(value),
        'bookingNumber': value.bookingNumber,
        'bookingState': ApiBookingStateToJSON(value.bookingState),
        'bookingDate': (value.bookingDate),
        'price': ApiPriceToJSON(value.price),
        'openAmount': ApiPriceToJSON(value.openAmount),
        'totalDiscount': ApiPriceToJSON(value.totalDiscount),
        'travelers': (value.travelers.map(ApiTravelerToJSON)),
        'payments': (value.payments.map(ApiPaymentToJSON)),
        'items': (value.items.map(ApiItemToJSON)),
        'bookedItems': (value.bookedItems.map(ApiBookedItemToJSON)),
        'documents': (value.documents.map(ApiDocumentToJSON)),
        'client': ApiClientToJSON(value.client),
        'affiliateNumber': value.affiliateNumber,
        'travelStartDate': (value.travelStartDate),
        'travelEndDate': (value.travelEndDate),
        'paymentState': ApiPaymentStateToJSON(value.paymentState),
        'paymentDueDate': value.paymentDueDate === undefined ? undefined : (value.paymentDueDate),
        'depositPayment': ApiDepositPaymentDataToJSON(value.depositPayment),
        'finalPayment': ApiFinalPaymentDataToJSON(value.finalPayment),
        'notes': value.notes === undefined ? undefined : (value.notes.map(ApiNoteToJSON)),
        'promoCodes': value.promoCodes,
        'bookingCustomProperties': value.bookingCustomProperties === undefined ? undefined : (value.bookingCustomProperties.map(ApiBookingCustomPropertyToJSON)),
        'catalogCode': value.catalogCode,
        'salesChannel': value.salesChannel,
        'rebookingId': value.rebookingId,
        'changedAmount': ApiPriceToJSON(value.changedAmount),
        'cartData': ApiCartDataToJSON(value.cartData),
        'paymentOption': ApiPaymentOptionToJSON(value.paymentOption),
        'captureData': value.captureData === undefined ? undefined : (value.captureData.map(ApiCaptureDataToJSON)),
        'blockchainWallet': ApiBlockchainWalletToJSON(value.blockchainWallet),
        'metaData': value.metaData,
        'sumPriceSysCurr': ApiPriceToJSON(value.sumPriceSysCurr),
        'discounts': value.discounts === undefined ? undefined : (value.discounts.map(ApiDiscountToJSON)),
        'brand': value.brand,
    };
}

export { ApiBookingFromJSON, ApiBookingFromJSONTyped, ApiBookingToJSON };
//# sourceMappingURL=ApiBooking.js.map
